var BulkStatus = /* @__PURE__ */ ((BulkStatus2) => {
  BulkStatus2["Success"] = "Success";
  BulkStatus2["Warning"] = "Warning";
  return BulkStatus2;
})(BulkStatus || {});
export {
  BulkStatus
};
//# sourceMappingURL=types.js.map
